module.exports = __webpack_public_path__ + "static/media/utilities.ea2e433d.svg";